/* Bullantic International — header horse & rider
   Procedural gait (IK) and a hover-follow controller. No dependencies. */
(function () {
  'use strict';
  if (window.__bullanticHorse) return;
  window.__bullanticHorse = true;

  var D = document, W = window;

  /* ----------------------------------------------------------- rig data */
  /* Joint positions in the SVG viewBox (240 x 152). Ground line y = 140.
     N = near side (towards the viewer), F = far side. */
  var J = {
    shN: [86, 70], knN: [91, 110], ftN: [85, 127], hfN: [82, 140],
    shF: [78, 71], knF: [83, 111], ftF: [77, 128], hfF: [74, 141],
    hpN: [150, 78], stN: [138, 94], hkN: [155, 113], fhN: [151, 128], hhN: [148, 140],
    hpF: [143, 79], stF: [131, 95], hkF: [148, 114], fhF: [144, 129], hhF: [141, 141]
  };
  var PAIRS = {
    fup: ['shN', 'knN'], flo: ['knN', 'ftN'], fhf: ['ftN', 'hfN'],
    hup: ['hpN', 'stN'], hmd: ['stN', 'hkN'], hlo: ['hkN', 'fhN'], hhf: ['fhN', 'hhN']
  };
  var VB = { w: 240, h: 152, ground: 140, com: 112, px: 116, py: 74 };

  var L = {}, R = {};
  function ang(a, b) { return Math.atan2(-(b[0] - a[0]), b[1] - a[1]) * 180 / Math.PI; }
  function len(a, b) { return Math.hypot(b[0] - a[0], b[1] - a[1]); }
  for (var k in PAIRS) {
    L[k] = len(J[PAIRS[k][0]], J[PAIRS[k][1]]);
    R[k] = ang(J[PAIRS[k][0]], J[PAIRS[k][1]]);
  }

  /* Footfall patterns. duty = share of the cycle a hoof is planted.
     Walk is a four-beat lateral sequence; trot is diagonal pairs. */
  /* stride = how far the hoof travels while planted; duty = the share of the
     cycle it is down; heel = how far it is off the ground at each end of
     stance, which is what keeps the leg inside its reach at full extension. */
  var GAITS = {
    walk:   { duty: 0.66, stride: 30, lift: 8,  heel: 3,  bob: 1.1, beats: 4,
              off: { fN: 0, hF: 0.25, fF: 0.5, hN: 0.75 } },
    trot:   { duty: 0.48, stride: 44, lift: 14, heel: 6,  bob: 2.6, beats: 2,
              off: { fN: 0, hF: 0, fF: 0.5, hN: 0.5 } },
    gallop: { duty: 0.18, stride: 58, lift: 24, heel: 10, bob: 4.6, beats: 1,
              off: { hF: 0, hN: 0.12, fF: 0.5, fN: 0.62 } }
  };
  var ORDER = ['walk', 'trot', 'gallop'];
  var ANCHOR = [24, 120, 300];   /* viewBox units/sec at which each gait is pure */

  /* Where he sits along walk -> trot -> gallop, as one continuous number.
     Blending rather than switching is what stops the legs snapping, and the
     number is rate-limited below so a hard acceleration cannot yank it. */
  function gaitScalar(vu) {
    if (vu <= ANCHOR[0]) return 0;
    if (vu >= ANCHOR[2]) return 2;
    var i = vu < ANCHOR[1] ? 0 : 1;
    return i + (vu - ANCHOR[i]) / (ANCHOR[i + 1] - ANCHOR[i]);
  }
  var MAXSPEED = 215;
  var TURN_DUR = 0.46;         /* seconds to come round */
  var VIS_L = 37, VIS_R = 172; /* viewBox extents of the drawing */
  var POST_GAP = 14;           /* px he keeps clear of the menu */
  var LANCE_PIVOT = [103, 51];     /* his hand */
  var LANCE_TIP = [53, -6.5];      /* where the pennant is bent on */
  var CLOTH_TOP = 7 / 40;          /* cloth's top edge within the flag box */
  var FLAG_H = 26;                 /* must match the height in the CSS */
  var FLAG_BITE = 2;               /* px the hoist sits into the shaft */
  var UNION_W = 33.8;              /* canton width in px; twice its height */
  var LANCE_CARRY = 76;            /* degrees back, at the carry */
  var LANCE_LEAN = 41.22;          /* shaft angle off vertical, from the drawing */
  var FLIP_ORIGIN = 0.52;          /* must match transform-origin in the CSS */

  function ik2(root, tx, ty, l1, l2, bend) {
    var dx = tx - root[0], dy = ty - root[1];
    var d = Math.min(l1 + l2 - 0.01, Math.max(Math.abs(l1 - l2) + 0.01, Math.hypot(dx, dy)));
    var a = Math.acos(Math.max(-1, Math.min(1, (l1 * l1 + d * d - l2 * l2) / (2 * l1 * d))));
    var j = Math.atan2(dy, dx) + bend * a;
    return [root[0] + l1 * Math.cos(j), root[1] + l1 * Math.sin(j)];
  }

  /* The hoof rises a little towards each end of stance — breakover at the back,
     reaching at the front — and the swing arc starts and finishes at exactly
     that height, so there is no step where one hands over to the other. */
  var EDGE = 0.35;
  function footPos(G, leg, phase, base) {
    var p = (phase + G.off[leg]) % 1; if (p < 0) p += 1;
    var S = G.stride, Dt = G.duty;
    if (p < Dt) {                                    /* stance — hoof planted */
      var t = p / Dt;
      return [base[0] - S / 2 + S * t,
              base[1] - Math.max(0, Math.abs(t * 2 - 1) - EDGE) / (1 - EDGE) * G.heel];
    }
    var s = (p - Dt) / (1 - Dt);                     /* swing — hoof arcs forward */
    var e = s * s * (3 - 2 * s);
    return [base[0] + S / 2 - S * e,
            base[1] - (G.heel + Math.sin(Math.PI * s) * (G.lift - G.heel))];
  }

  /* ------------------------------------------------------------- the tail */
  /* A chain of segments rather than a fixed shape. At rest it hangs and hooks
     forward; under speed it streams back and lifts, and it lags behind him so
     it flows instead of swinging like a rigid plank. */
  var TAIL_ROOT = [152, 57];
  var TAIL_SEG = [8.96, 11.36, 12.65, 12.11, 11.12, 9.85, 8.93, 6.03, 5.94];
  var TAIL_W = [2.0, 3.4, 5.4, 7.2, 8.0, 7.2, 5.6, 3.8, 2.0, 0.9];
  var HANG = [[0.625, 0.781], [0.475, 0.880], [0.316, 0.949], [0.132, 0.991],
              [-0.144, 0.989], [-0.406, 0.914], [-0.672, 0.739], [-0.995, -0.100],
              [-0.673, -0.741]];
  var STREAM = [[0.55, 0.83], [0.75, 0.66], [0.90, 0.44], [0.98, 0.20], [1.00, -0.05],
                [0.96, -0.28], [0.88, -0.47], [0.76, -0.65], [0.62, -0.78]];

  function chainOffset(P, off) {
    var n = P.length, out = [];
    for (var i = 0; i < n; i++) {
      var tx, ty;
      if (i === 0) { tx = P[1][0] - P[0][0]; ty = P[1][1] - P[0][1]; }
      else if (i === n - 1) { tx = P[i][0] - P[i - 1][0]; ty = P[i][1] - P[i - 1][1]; }
      else { tx = P[i + 1][0] - P[i - 1][0]; ty = P[i + 1][1] - P[i - 1][1]; }
      var L = Math.hypot(tx, ty) || 1;
      out.push([P[i][0] - ty / L * off, P[i][1] + tx / L * off]);
    }
    return out;
  }

  function smoothClosed(P) {
    var n = P.length, d = 'M' + P[0][0].toFixed(1) + ' ' + P[0][1].toFixed(1);
    for (var i = 0; i < n; i++) {
      var p0 = P[(i - 1 + n) % n], p1 = P[i], p2 = P[(i + 1) % n], p3 = P[(i + 2) % n];
      d += 'C' + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + ' ' +
           (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) + ' ' +
           (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + ' ' +
           (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) + ' ' +
           p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    }
    return d + 'Z';
  }

  function smoothOpen(P) {
    var n = P.length, d = 'M' + P[0][0].toFixed(1) + ' ' + P[0][1].toFixed(1);
    for (var i = 0; i < n - 1; i++) {
      var p0 = P[Math.max(0, i - 1)], p1 = P[i], p2 = P[i + 1], p3 = P[Math.min(n - 1, i + 2)];
      d += 'C' + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + ' ' +
           (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) + ' ' +
           (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + ' ' +
           (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) + ' ' +
           p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    }
    return d;
  }

  function ribbonPath(P, wScale, count) {
    var n = count || P.length, left = [], right = [];
    for (var i = 0; i < n; i++) {
      var tx, ty;
      if (i === 0) { tx = P[1][0] - P[0][0]; ty = P[1][1] - P[0][1]; }
      else if (i === n - 1) { tx = P[i][0] - P[i - 1][0]; ty = P[i][1] - P[i - 1][1]; }
      else { tx = P[i + 1][0] - P[i - 1][0]; ty = P[i + 1][1] - P[i - 1][1]; }
      var L = Math.hypot(tx, ty) || 1, w = TAIL_W[i] * wScale;
      left.push([P[i][0] - ty / L * w, P[i][1] + tx / L * w]);
      right.push([P[i][0] + ty / L * w, P[i][1] - tx / L * w]);
    }
    return smoothClosed(left.concat(right.reverse()));
  }

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }

  /* ---------------------------------------------------------------- init */
  function init(root) {
    var svg = root.querySelector('svg');
    if (!svg) return;

    var header = root.closest('header, .site-header') ||
                 D.querySelector('.site-header') || D.querySelector('header');
    if (!header) return;
    if (root.parentNode !== header) header.appendChild(root);
    if (getComputedStyle(header).position === 'static') header.style.position = 'relative';

    var navSel = '.site-nav > li, .nav-bar li.site-nav__item, .site-nav__item';
    var nav = header.querySelector('.nav-bar, .site-nav');
    var items = [];
    function collect() {
      items = [];
      var list = (nav || header).querySelectorAll(navSel);
      for (var i = 0; i < list.length; i++) {
        var li = list[i];
        if (li.closest('.site-nav__dropdown')) continue;   /* mega-menu children */
        if (items.indexOf(li) === -1 && li.offsetParent !== null) items.push(li);
      }
    }
    collect();
    if (!items.length) { root.hidden = true; return; }

    var KEYS = ['torso', 'head', 'mane', 'tail', 'rider', 'hat', 'coat', 'mark', 'lance',
      'earN', 'earF', 'eye', 'rboot',
      'fupN', 'fmdN', 'floN', 'fupF', 'fmdF', 'floF',
      'hupN', 'hmd2N', 'hmdN', 'hloN', 'hupF', 'hmd2F', 'hmdF', 'hloF'];
    var nodes = {}, lastT = {};
    KEYS.forEach(function (key) { nodes[key] = svg.querySelectorAll('[data-j="' + key + '"]'); });
    function setT(key, v) {
      if (lastT[key] === v) return;
      lastT[key] = v;
      var n = nodes[key];
      for (var i = 0; i < n.length; i++) n[i].setAttribute('transform', v);
    }

    /* ---------------------------------------------------------- the flag */
    var tipEl = null, tipOn = false, tipWait = 0;
    (function () {
      var txt = (root.getAttribute('data-tip') || '').trim();
      if (!txt) return;
      tipEl = D.createElement('div');
      tipEl.className = 'bl-horse__flag';
      tipEl.setAttribute('aria-hidden', 'true');
      /* The cloth is redrawn every frame, so the shape here is only a
         starting pose — see waveFlag(). */
      tipEl.innerHTML =
        '<svg class="bl-horse__flag-cloth" viewBox="0 0 300 40" ' +
          'preserveAspectRatio="none" aria-hidden="true" focusable="false">' +
          '<defs><clipPath id="blFlagClip"><path class="bl-flag-clip"/></clipPath></defs>' +
          '<path class="bl-horse__flag-fill bl-flag-body"/>' +
          '<g class="bl-flag-union"></g>' +
          '<g clip-path="url(#blFlagClip)">' +
            '<rect class="bl-horse__flag-sheen" x="-70" y="-8" width="54" height="56" ' +
              'transform="skewX(-18)"/>' +
          '</g>' +
          '<path class="bl-horse__flag-edge bl-flag-top"/>' +
          '<path class="bl-horse__flag-edge bl-flag-bot"/>' +
        '</svg>' +
        '<span class="bl-horse__flag-text">' + splitChars(txt) + '</span>';
      header.appendChild(tipEl);
      root.classList.add('has-flag');   /* the lance is the flagpole */
    })();

    /* The pennant is bent on to the lance, so its position is measured from a
       marker inside the drawing rather than worked out. That way the mirror the
       flip applies, the perspective, the scale and the lance's own swing are all
       already accounted for — computing it by hand got this wrong by 5px,
       because the flip mirrors about 52% of the box rather than the middle. */
    function placeTip() {
      if (!tipEl) return;
      var hr = header.getBoundingClientRect();
      var right = S.face > 0;
      var tipX, topY;
      var ar = anchorEl && anchorEl.getBoundingClientRect &&
               anchorEl.getBoundingClientRect();
      if (ar && (ar.width || ar.height)) {
        tipX = ar.left + ar.width / 2 - hr.left;
        topY = ar.top + ar.height / 2 - hr.top;
      } else {
        tipX = S.x + (right ? 2 * FLIP_ORIGIN * VB.w - LANCE_TIP[0]
                            : LANCE_TIP[0]) * M.scale;
        topY = hr.height + (VB.h - VB.ground) * M.scale - M.size + LANCE_TIP[1] * M.scale;
      }
      tipEl.classList.toggle('is-left', !right);
      tipEl.style.setProperty('--bl-flag-skew',
        (right ? -LANCE_LEAN : LANCE_LEAN).toFixed(2) + 'deg');
      /* the drawn cloth starts a little below the box, so lift the box by
         that much and the hoist's top corner lands on the pole */
      tipEl.style.top =
        Math.max(2, topY - (tipEl.offsetHeight || FLAG_H) * CLOTH_TOP) + 'px';
      var w = tipEl.offsetWidth || 240;
      var left = right ? tipX + FLAG_BITE : tipX - w - FLAG_BITE;
      tipEl.style.left = clamp(left, 4, Math.max(4, hr.width - w - 4)) + 'px';
      tipEl.style.right = 'auto';
    }

    /* One element per letter, so each can be set against the piece of cloth
       under it. The house name keeps its gold wherever it falls. */
    function splitChars(txt) {
      var low = txt.toLowerCase(), gold = {}, i, k;
      var at = low.indexOf('bullantic');
      while (at !== -1) {
        for (k = 0; k < 9; k++) gold[at + k] = 1;
        at = low.indexOf('bullantic', at + 9);
      }
      var out = '';
      for (i = 0; i < txt.length; i++) {
        var ch = txt.charAt(i);
        var esc = ch === '&' ? '&amp;' : ch === '<' ? '&lt;' :
                  ch === '>' ? '&gt;' : ch === ' ' ? '&#160;' : ch;
        out += '<i class="bl-flag-ch' + (gold[i] ? ' is-gold' : '') + '">' + esc + '</i>';
      }
      return out;
    }

    /* The cloth SVG is stretched to the banner's length, so anything drawn in
       it is squashed. The canton is scaled back by the same amount, which lands
       it exactly square on screen — and its strokes stay circular. */
    function unionCanton(w, mirror) {
      var uw = UNION_W * 300 / Math.max(60, w);      /* viewBox units */
      var sx = (uw / 60).toFixed(4), sy = (26 / 30).toFixed(4);
      var F = 'var(--bl-flag-union-field)', C = 'var(--bl-flag-union-cream)';
      var R = 'var(--bl-flag-union-red)';
      var place = mirror ? 'translate(300 7) scale(-' + sx + ' ' + sy + ')'
                         : 'translate(0 7) scale(' + sx + ' ' + sy + ')';
      /* The clip has to sit on a group of its own. Put it on the same group as
         the transform and the browser scales the clipping path too, which
         shrinks it away from the top of the cloth. */
      return '<g clip-path="url(#blFlagClip)"><g transform="' + place + '">' +
        '<rect width="60" height="30" fill="' + F + '"/>' +
        '<path d="M0 0L60 30M0 30L60 0" stroke="' + C + '" stroke-width="6"/>' +
        '<path d="M0 0L60 30M0 30L60 0" stroke="' + R + '" stroke-width="2"/>' +
        '<path d="M0 15H60M30 0V30" stroke="' + C + '" stroke-width="10"/>' +
        '<path d="M0 15H60M30 0V30" stroke="' + R + '" stroke-width="6"/>' +
        '<path d="M60 0V30" stroke="var(--bl-flag-accent)" stroke-width="2.4"/>' +
        '</g></g>';
    }

    var flagPart = {}, flagChars = [], flagW = 200;
    function grabFlagParts() {
      if (!tipEl) return;
      ['bl-flag-clip', 'bl-flag-body', 'bl-flag-top', 'bl-flag-bot',
       'bl-flag-union'].forEach(function (k) {
        flagPart[k] = tipEl.querySelector('.' + k);
      });
      flagPart.text = tipEl.querySelector('.bl-horse__flag-text');
      if (flagPart['bl-flag-union']) {
        flagPart['bl-flag-union'].innerHTML =
          unionCanton(tipEl.offsetWidth || 200, S.face < 0);
      }
      flagChars = [];
      var box = tipEl.getBoundingClientRect();
      var list = tipEl.querySelectorAll('.bl-flag-ch');
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        flagChars.push({ el: list[i], cx: r.left + r.width / 2 - box.left });
      }
      flagW = tipEl.offsetWidth || 200;
    }

    /* Cubic through a run of points, without the leading move. */
    function curveOn(P) {
      var n = P.length, d = '';
      for (var i = 0; i < n - 1; i++) {
        var p0 = P[Math.max(0, i - 1)], p1 = P[i];
        var p2 = P[i + 1], p3 = P[Math.min(n - 1, i + 2)];
        d += 'C' + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(2) + ' ' +
             (p1[1] + (p2[1] - p0[1]) / 6).toFixed(2) + ' ' +
             (p2[0] - (p3[0] - p1[0]) / 6).toFixed(2) + ' ' +
             (p2[1] - (p3[1] - p1[1]) / 6).toFixed(2) + ' ' +
             p2[0].toFixed(2) + ' ' + p2[1].toFixed(2);
      }
      return d;
    }

    /* A wave travelling from the hoist to the fly. The hoist is bent on to the
       pole so it cannot move; the amplitude grows along the length, which is
       why the fly end whips and the pole end barely stirs. */
    var FLY = 264, SPAN = 300, TOP0 = 7, BOT0 = 33;
    var TWO_PI = Math.PI * 2, CYCLES = 1.55;   /* ripples along its length */
    /* centre line of the cloth at a point along it */
    function midAt(x, t, gust) {
      var a = 7.2 * Math.pow(clamp(x, 0, SPAN) / SPAN, 1.3) * gust;
      var ph = (x / SPAN) * TWO_PI * CYCLES - t * 3.4;
      return (TOP0 + Math.sin(ph) * a + BOT0 + Math.sin(ph + 0.4) * a) / 2;
    }

    function waveFlag(t, gust, mirror) {
      var N = 13, top = [], bot = [], i, x, a, ph;
      for (i = 0; i < N; i++) {
        x = (i / (N - 1)) * FLY;
        a = 7.2 * Math.pow(x / SPAN, 1.3) * gust;
        ph = (x / SPAN) * TWO_PI * CYCLES - t * 3.4;
        var px = mirror ? SPAN - x : x;
        top.push([px, TOP0 + Math.sin(ph) * a]);
        bot.push([px, BOT0 + Math.sin(ph + 0.4) * a]);
      }
      var ae = 7.2 * Math.pow(FLY / SPAN, 1.3) * gust;
      var pe = TWO_PI * CYCLES * (FLY / SPAN) - t * 3.4;
      var e = Math.sin(pe) * ae, e2 = Math.sin(pe + 0.4) * ae;
      /* the three tails, each lagging a little further behind */
      var fx = mirror ? 0 : 300, nx = mirror ? 30 : 270;
      var tails = 'L' + fx + ' ' + (1 + e * 1.55).toFixed(2) +
                  ' L' + nx + ' ' + (14 + e * 1.2).toFixed(2) +
                  ' L' + fx + ' ' + (20 + e * 1.35).toFixed(2) +
                  ' L' + nx + ' ' + (26 + e2 * 1.2).toFixed(2) +
                  ' L' + fx + ' ' + (39 + e2 * 1.55).toFixed(2) + ' ';
      var head = 'M' + top[0][0].toFixed(2) + ' ' + top[0][1].toFixed(2) + ' ';
      var body = head + curveOn(top) + tails + curveOn(bot.slice().reverse()) + 'Z';
      if (flagPart['bl-flag-body']) flagPart['bl-flag-body'].setAttribute('d', body);
      if (flagPart['bl-flag-clip']) flagPart['bl-flag-clip'].setAttribute('d', body);
      if (flagPart['bl-flag-top'])
        flagPart['bl-flag-top'].setAttribute('d', head + curveOn(top));
      if (flagPart['bl-flag-bot'])
        flagPart['bl-flag-bot'].setAttribute('d',
          'M' + bot[0][0].toFixed(2) + ' ' + bot[0][1].toFixed(2) + ' ' + curveOn(bot));
      /* Each letter is set against the cloth beneath it — the centre line of
         the wave at that point, and its slope — so the wording rides the cloth
         instead of sliding off it. The lean is allowed for: the cloth is
         skewed and the wording is not, so the piece of cloth under a letter
         sits about half the flag's height further along. */
      if (flagChars.length) {
        var k = 300 / Math.max(60, flagW), lead = 13 * Math.tan(LANCE_LEAN * Math.PI / 180);
        for (var c = 0; c < flagChars.length; c++) {
          var ch = flagChars[c];
          var vx = clamp((ch.cx + lead) * k, 0, FLY);
          var y0 = midAt(vx - 7, t, gust), y1 = midAt(vx + 7, t, gust);
          var dy = ((y0 + y1) / 2 - 20) * 0.65;
          var ang = Math.atan2((y1 - y0) * 0.65, 14 / k) * 180 / Math.PI;
          ch.el.style.transform =
            'translateY(' + dy.toFixed(2) + 'px) rotate(' + ang.toFixed(2) + 'deg)';
        }
      }
    }

    function showTip(on) {
      if (!tipEl || on === tipOn) return;
      tipOn = on;
      if (on) { grabFlagParts(); S.flagT = 0; placeTip(); }
      tipEl.classList.toggle('is-on', on);
    }

    var anchorEl = svg.querySelector('.bl-anchor');
    var tailEl = {}, tailPts = [];
    (function () {
      ['m', 'o', 'i', 'p0', 'p1', 'p2', 'p3', 'p4'].forEach(function (k) {
        tailEl[k] = svg.querySelector('[data-tp="' + k + '"]');
      });
      var x = TAIL_ROOT[0], y = TAIL_ROOT[1];
      tailPts.push([x, y]);
      for (var i = 0; i < TAIL_SEG.length; i++) {
        x += HANG[i][0] * TAIL_SEG[i]; y += HANG[i][1] * TAIL_SEG[i];
        tailPts.push([x, y]);
      }
    })();

    function stepTail(dt) {
      if (!tailEl.m) return;
      var wind = clamp(Math.abs(S.v) / M.scale / 260, 0, 0.85) + S.turnAmt * 0.25;
      wind = clamp(wind, 0, 0.9);
      var sway = Math.sin(S.t * 2.1) * (0.5 + wind * 2.2);
      var P = tailPts;
      P[0][0] = TAIL_ROOT[0]; P[0][1] = TAIL_ROOT[1];
      for (var i = 0; i < TAIL_SEG.length; i++) {
        var h = HANG[i], st = STREAM[i];
        var dx = h[0] + (st[0] - h[0]) * wind;
        var dy = h[1] + (st[1] - h[1]) * wind;
        var sw = sway * (i / TAIL_SEG.length) * 0.07;
        var ux = dx, uy = dy;
        dx = ux - uy * sw; dy = uy + ux * sw;
        var L = Math.hypot(dx, dy) || 1;
        var tx = P[i][0] + dx / L * TAIL_SEG[i];
        var ty = P[i][1] + dy / L * TAIL_SEG[i];
        var k = 1 - Math.exp(-dt * (15 - i * 1.25));   /* the tip lags most */
        var q = P[i + 1];
        q[0] += (tx - q[0]) * k; q[1] += (ty - q[1]) * k;
        var ax = q[0] - P[i][0], ay = q[1] - P[i][1], al = Math.hypot(ax, ay) || 1;
        q[0] = P[i][0] + ax / al * TAIL_SEG[i];
        q[1] = P[i][1] + ay / al * TAIL_SEG[i];
      }
      tailEl.m.setAttribute('d', ribbonPath(P, 1));
      if (tailEl.o) tailEl.o.setAttribute('d', ribbonPath(chainOffset(P, 2.2), 0.44));
      if (tailEl.i) tailEl.i.setAttribute('d', ribbonPath(chainOffset(P, -2.6), 0.48, 8));
      var offs = [-4.4, -1.6, 1.6, 4.2, 6.2];
      for (var j = 0; j < 5; j++) {
        var el = tailEl['p' + j];
        if (el) el.setAttribute('d', smoothOpen(chainOffset(P, offs[j])));
      }
    }

    /* ------------------------------------------------------------ layout */
    var flip = root.querySelector('.bl-horse__flip');
    var M = { scale: 0.26, w: 63, size: 40, home: 0, min: 0, max: 0, facing: 1, ok: true };

    function measure() {
      collect();
      if (!items.length) { root.hidden = true; M.ok = false; return; }
      var hr = header.getBoundingClientRect();
      var first = items[0].getBoundingClientRect();
      var last = items[items.length - 1].getBoundingClientRect();

      /* fit the clear band beneath the menu text, so he never covers a link */
      var size = parseFloat(root.getAttribute('data-size') || '') || 0;
      if (!size) {
        var link = items[0].querySelector('a, button') || items[0];
        var pad = parseFloat(getComputedStyle(link).paddingBottom) || 0;
        var clear = (hr.bottom - link.getBoundingClientRect().bottom) + pad;
        if (!(clear > 12)) clear = hr.height * 0.4;
        size = clamp(clear / 0.92 - 2, 34, 108);
      }
      M.size = size;
      M.scale = size / VB.h;
      M.w = VB.w * M.scale;

      var lift = parseFloat(root.getAttribute('data-lift') || '') || 0;
      root.style.setProperty('--bl-horse-size', size + 'px');
      root.style.bottom = (-(VB.h - VB.ground) * M.scale + lift) + 'px';

      var leftRoom = first.left - hr.left;
      var rightRoom = hr.right - last.right;
      var pref = root.getAttribute('data-home') || 'auto';
      var useLeft = pref === 'left' ? true : pref === 'right' ? false
                  : leftRoom >= rightRoom;
      M.useLeft = useLeft;
      M.navLeft = first.left - hr.left;
      M.navRight = last.right - hr.left;

      /* Worst-case extents of the drawing inside its box, whichever way he
         faces — so his post does not shift when he turns round. */
      M.extR = Math.max(VB.w - VIS_L, VIS_R) * M.scale;
      M.extL = Math.min(VIS_L, VB.w - VIS_R) * M.scale;

      /* Where he pulls up. By default he stops alongside the item — on the
         side he came from — so his nose reaches it but his body never crosses
         the wording. */
      var stand = root.getAttribute('data-stand') || 'auto';
      M.stand = (stand === 'item' || stand === 'beside') ? stand : 'edge';
      M.noseR = (VB.w - VIS_L) * M.scale;   /* nose, when he faces right */
      M.noseL = VIS_L * M.scale;            /* nose, when he faces left */
      /* He waits on one side and pulls up at the far end of the menu, so the
         run is the width of the header and he ends up alongside the wording
         rather than on top of it. */
      M.post = useLeft ? M.navRight + POST_GAP - M.extL
                       : M.navLeft - POST_GAP - M.extR;
      M.postFace = useLeft ? -1 : 1;      /* turn back to face the menu */
      M.min = 4;
      M.max = Math.max(M.min, hr.width - M.w - 4);
      M.post = clamp(M.post, M.min, M.max);
      M.home = clamp(useLeft ? Math.max(6, leftRoom * 0.26)
                             : (last.right - hr.left) + Math.max(8, (rightRoom - M.w) * 0.45),
                     M.min, M.max);
      M.facing = useLeft ? 1 : -1;
      M.ok = W.innerWidth >= 992;
      root.hidden = !M.ok;
      if (S.x === null) { S.x = M.home; S.tx = M.home; }
    }

    /* ------------------------------------------------------------- state */
    var S = {
      x: null, tx: 0, v: 0, phase: 0, gs: 0, ga: 0, gb: 1, gt: 0, sp: 0, act: 0,
      faceA: 0, turnFrom: 0, turnTo: 0, turnT: 1, turnAmt: 0, side: 1, lance: 0, flagT: 0,
      face: -1,                 /* -1 = drawn facing left, +1 = mirrored */
      target: null, t: 0,
      blink: 2.4, blinkA: 0, ear: 3, earA: 0, look: 0, shift: 7, shiftA: 0
    };
    var reduced = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speedMul = parseFloat(root.getAttribute('data-speed') || '') || 1;

    /* ------------------------------------------------------------ events */
    /* Work out where he is heading once, when it changes — reading layout on
       every frame is what makes a header animation stutter. */
    /* His body centre in header coordinates, whichever way he is facing */
    function bodyMid() {
      return S.x + (S.face > 0 ? M.w - VB.com * M.scale : VB.com * M.scale);
    }

    function retarget() {
      if (!S.target) { S.tx = M.home; return; }
      if (M.stand === 'edge') { S.tx = M.post; return; }
      var hr = header.getBoundingClientRect(), r = S.target.getBoundingClientRect();
      var l = r.left - hr.left, rt = r.right - hr.left, c = (l + rt) / 2;
      if (M.stand === 'item') {
        S.tx = clamp(c - (S.face > 0 ? M.w - VB.com * M.scale : VB.com * M.scale),
                     M.min, M.max);
        return;
      }
      /* Alongside: nose to the near edge of the item, body clear of the word.
         The side is fixed when the target is picked so that turning to face it
         cannot move the post out from under him. */
      S.tx = clamp(S.side > 0 ? l - POST_GAP - M.noseR : rt + POST_GAP - M.noseL,
                   M.min, M.max);
    }
    function onOver(e) {
      var li = e.target.closest && e.target.closest(navSel);
      if (li && items.indexOf(li) !== -1 && li !== S.target) {
        S.target = li;
        var hr = header.getBoundingClientRect(), r = li.getBoundingClientRect();
        S.side = ((r.left + r.width / 2) - hr.left) >= bodyMid() ? 1 : -1;
        retarget();
      }
    }
    function onOut(e) {
      if (!e.relatedTarget || !(nav || header).contains(e.relatedTarget)) {
        S.target = null; retarget();
      }
    }
    var scope = nav || header;
    scope.addEventListener('pointerover', onOver, { passive: true });
    scope.addEventListener('pointerout', onOut, { passive: true });
    scope.addEventListener('focusin', onOver, { passive: true });
    scope.addEventListener('focusout', onOut, { passive: true });

    function remeasure() { measure(); retarget(); if (tipOn) placeTip(); }
    if (W.ResizeObserver) new ResizeObserver(remeasure).observe(header);
    W.addEventListener('resize', remeasure, { passive: true });
    W.addEventListener('load', remeasure);

    var visible = true;
    if (W.IntersectionObserver) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(header);
    }

    /* -------------------------------------------------------------- pose */
    function pose() {
      var GA = GAITS[ORDER[S.ga]], GB = GAITS[ORDER[S.gb]], gt = S.gt;
      var sp = S.sp, ph = S.phase;
      function two(fn) { return gt ? lerp(fn(GA), fn(GB), gt) : fn(GA); }
      function foot2(leg, base) {
        var a = footPos(GA, leg, ph, base);
        if (!gt) return a;
        var b = footPos(GB, leg, ph, base);
        return [lerp(a[0], b[0], gt), lerp(a[1], b[1], gt)];
      }
      var bob = two(function (G) {
        return -Math.abs(Math.sin(Math.PI * ph * G.beats)) * G.bob;
      }) * sp;
      var pitch = Math.sin(2 * Math.PI * ph) * 1.4 * sp;
      var breath = Math.sin(S.t * 1.5) * 0.35;
      setT('torso', 'translate(' + (S.shiftA * 0.5).toFixed(2) + ' ' +
        (bob + breath - S.turnAmt * 2.2).toFixed(2) + ') rotate(' +
        (pitch - S.turnAmt * 1.8).toFixed(2) + ' ' + VB.px + ' ' + VB.py + ')');

      /* legs ride inside the body group, so ground-space hoof targets are
         pulled back into body-local space — that is what keeps a planted
         hoof genuinely planted while the barrel bobs. */
      var cs = Math.cos(-pitch * Math.PI / 180), sn = Math.sin(-pitch * Math.PI / 180);
      function inv(p) {
        var x = p[0] - VB.px, y = p[1] - bob - breath - VB.py;
        return [VB.px + x * cs - y * sn, VB.py + x * sn + y * cs];
      }
      /* as he halts, hooves ease back under him rather than freezing mid-stride */
      function settle(p, base) {
        var a = S.act;
        return a > 0.999 ? p : [base[0] + (p[0] - base[0]) * a, base[1] + (p[1] - base[1]) * a];
      }
      function reach(rt, t, max) {
        var dx = t[0] - rt[0], dy = t[1] - rt[1], d = Math.hypot(dx, dy);
        return d <= max ? t : [rt[0] + dx * max / d, rt[1] + dy * max / d];
      }

      for (var s = 0; s < 2; s++) {
        var k = s ? 'F' : 'N';

        var sh = J['sh' + k];
        var ft = inv(settle(foot2('f' + k, J['hf' + k]), J['hf' + k]));
        var pa = clamp((ft[0] - sh[0]) * 0.5, -28, 28);
        var fet = reach(sh, [ft[0] + L.fhf * Math.sin(pa * Math.PI / 180),
                             ft[1] - L.fhf * Math.cos(pa * Math.PI / 180)],
                        (L.fup + L.flo) * 0.985);
        var kn = ik2(sh, fet[0], fet[1], L.fup, L.flo, -1);
        var w1 = ang(sh, kn), w2 = ang(kn, fet);
        setT('fup' + k, 'rotate(' + (w1 - R.fup).toFixed(2) +
          ' ' + J['sh' + k][0] + ' ' + J['sh' + k][1] + ')');
        setT('fmd' + k, 'rotate(' + (w2 - w1 - (R.flo - R.fup)).toFixed(2) +
          ' ' + J['kn' + k][0] + ' ' + J['kn' + k][1] + ')');
        setT('flo' + k, 'rotate(' + (pa - w2 - (R.fhf - R.flo)).toFixed(2) +
          ' ' + J['ft' + k][0] + ' ' + J['ft' + k][1] + ')');

        var hp = J['hp' + k];
        var fh = inv(settle(foot2('h' + k, J['hh' + k]), J['hh' + k]));
        var ca = clamp((fh[0] - hp[0]) * 0.34, -26, 26);
        var cl = L.hlo + L.hhf;
        var hock = reach(hp, [fh[0] + cl * Math.sin(ca * Math.PI / 180),
                              fh[1] - cl * Math.cos(ca * Math.PI / 180)],
                         (L.hup + L.hmd) * 0.985);
        var stf = ik2(hp, hock[0], hock[1], L.hup, L.hmd, 1);
        var v1 = ang(hp, stf), v2 = ang(stf, hock);
        var hlo = ca - v2 - (R.hlo - R.hmd);
        setT('hup' + k, 'rotate(' + (v1 - R.hup).toFixed(2) +
          ' ' + J['hp' + k][0] + ' ' + J['hp' + k][1] + ')');
        setT('hmd2' + k, 'rotate(' + (v2 - v1 - (R.hmd - R.hup)).toFixed(2) +
          ' ' + J['st' + k][0] + ' ' + J['st' + k][1] + ')');
        setT('hmd' + k, 'rotate(' + hlo.toFixed(2) +
          ' ' + J['hk' + k][0] + ' ' + J['hk' + k][1] + ')');
        setT('hlo' + k, 'rotate(' + (-hlo * 0.35).toFixed(2) +
          ' ' + J['fh' + k][0] + ' ' + J['fh' + k][1] + ')');
      }

      /* secondary motion, kept deliberately quiet */
      var nk = two(function (G) {
        return Math.sin(2 * Math.PI * ph * G.beats + 1.1);
      }) * 1.9 * sp;
      setT('head', 'rotate(' + (-nk * 0.8 + Math.sin(S.t * 1.1) * 0.5 - S.look * 3.4
        - S.turnAmt * 4.5).toFixed(2) + ' 58 20)');
      /* the house mark is lettering: mirror it back when he faces the other
         way, at the moment he is edge-on and nobody can see the swap */
      setT('lance', S.lance > 0.995 ? '' :
        'rotate(' + ((1 - S.lance) * LANCE_CARRY).toFixed(2) + ' ' +
        LANCE_PIVOT[0] + ' ' + LANCE_PIVOT[1] + ')');
      setT('mark', S.faceA > 90 ? 'translate(240 0) scale(-1 1)' : '');
      setT('mane', 'rotate(' + (nk * 0.4).toFixed(2) + ' 58 19)');
      setT('tail', S.turnAmt ? 'rotate(' + (-S.turnAmt * 10).toFixed(2) + ' 152 57)' : '');
      setT('rider', 'translate(0 ' + (bob * 0.4).toFixed(2) + ') rotate(' +
        (pitch * 0.5 + S.turnAmt * 3.4).toFixed(2) + ' 116 56)');
      setT('hat', 'rotate(' + (-nk * 0.3).toFixed(2) + ' 106 11)');
      setT('coat', 'rotate(' + (4 * sp).toFixed(2) + ' 122 49)');
      setT('rboot', 'rotate(' + (two(function (G) {
        return Math.sin(2 * Math.PI * ph * G.beats + 0.6);
      }) * 2.4 * sp).toFixed(2) + ' 107.6 68.6)');
      setT('earN', 'rotate(' + (-S.look * 7 + S.earA).toFixed(2) + ' 60 20)');
      setT('earF', 'rotate(' + (-S.look * 5 + S.earA * 0.7).toFixed(2) + ' 56 20)');
      setT('eye', S.blinkA > 0.02
        ? 'translate(50.6 28.4) scale(1 ' + (1 - S.blinkA * 0.9).toFixed(2) +
          ') translate(-50.6 -28.4)'
        : '');
    }

    /* -------------------------------------------------------------- tick */
    var prev = 0;
    function frame(now) {
      requestAnimationFrame(frame);
      if (!M.ok || root.hidden || !visible || D.hidden) { prev = now; return; }
      var dt = prev ? Math.min(0.05, (now - prev) / 1000) : 0.016;
      prev = now;
      S.t += dt;


      if (reduced) { S.x = S.tx; S.sp = 0; S.act = 0; S.turnT = 1; }
      else {
        /* Coming round: a real vertical-axis rotation, quickest through the
           middle so the moment he is edge-on passes in a frame or two. */
        if (S.turnT < 1) {
          S.turnT = Math.min(1, S.turnT + dt / TURN_DUR);
          var q = S.turnT;
          var e = q < 0.5 ? 4 * q * q * q : 1 - 4 * (1 - q) * (1 - q) * (1 - q);
          S.faceA = S.turnFrom + (S.turnTo - S.turnFrom) * e;
          S.turnAmt = Math.sin(Math.PI * q);
          flip.style.transform = 'rotateY(' + S.faceA.toFixed(1) + 'deg)';
        } else if (S.turnAmt) {
          S.turnAmt = 0;
        }

        var dx = S.tx - S.x;
        var want = clamp(dx * 4.2, -MAXSPEED * speedMul, MAXSPEED * speedMul);
        if (Math.abs(dx) < 1.2) want = 0;
        want *= 1 - 0.72 * S.turnAmt;      /* he checks his stride to come round */
        S.v = lerp(S.v, want, 1 - Math.exp(-dt * 3.5));
        /* Snap home only once he is genuinely there. Killing the velocity on a
           flat threshold instead leaves him stalled short of the mark, because
           the drive falls under the threshold before the gap closes. */
        if (want === 0 && Math.abs(S.v) < 4) { S.v = 0; S.x = S.tx; }
        else S.x += S.v * dt;

        var wantFace = S.face;
        if (Math.abs(dx) > 8) wantFace = dx > 0 ? 1 : -1;
        else if (S.target && M.stand === 'edge') wantFace = M.postFace;
        else if (S.target && M.stand === 'beside') wantFace = S.side;
        if (wantFace !== S.face && Math.abs(S.v) < 150) {
          S.face = wantFace;
          S.turnFrom = S.faceA;
          S.turnTo = S.face > 0 ? 180 : 0;
          S.turnT = 0;
          retarget();
        }

        /* gait by speed, in viewBox units so it is independent of his size */
        var vu = Math.abs(S.v) / M.scale;
        /* Pick the gait from where he is going, not only from where he is: a
           horse gathers into a gallop as it sets off rather than after. Falling
           back to actual speed on the way down means he winds down honestly. */
        var vg = Math.max(Math.abs(S.v), Math.abs(want) * 0.8) / M.scale;
        var rate = 5 * dt;
        var gTarget = gaitScalar(vg) * (1 - 0.85 * S.turnAmt);   /* gather to a walk */
        S.gs += clamp(gTarget - S.gs, -rate, rate);
        S.ga = Math.min(1, Math.floor(S.gs));
        S.gb = S.ga + 1;
        S.gt = S.gs - S.ga;
        S.sp = clamp(vu / 150, 0, 1);

        /* Ground covered per stride is the hoof's excursion divided by the duty
           factor: the hoof is planted for `duty` of the cycle and the rest of
           the ground is made up in the air. Advancing the phase on that basis
           is what keeps a planted hoof planted. Past a leg cadence a real horse
           could not hold, we let it slip rather than blur. */
        var ga = GAITS[ORDER[S.ga]], gb = GAITS[ORDER[S.gb]];
        var perStride = lerp(ga.stride / ga.duty, gb.stride / gb.duty, S.gt) * M.scale;
        var cadence = Math.abs(S.v) / perStride;
        var slip = cadence > 3.4 ? cadence / 3.4 : 1;
        if (Math.abs(S.v) > 1) {
          S.phase = (S.phase + (Math.abs(S.v) * dt) / (perStride * slip)) % 1;
        }
        /* keep his feet moving through the turn — a horse steps round, it does
           not pivot on the spot like a weathervane */
        if (S.turnAmt > 0.02) {
          S.phase = (S.phase + dt * 1.45 * S.turnAmt) % 1;
          S.sp = Math.max(S.sp, 0.45 * S.turnAmt);
          S.act = Math.max(S.act, S.turnAmt);
        }
      }

      /* quiet idle life: breathing, a slow tail, the odd blink and ear flick,
         and an occasional shift of weight */
      var moving = Math.abs(S.v) > 6;
      S.act = lerp(S.act, moving ? 1 : 0, 1 - Math.exp(-dt * 6));
      if (S.act < 0.004) S.act = 0;
      S.blink -= dt; S.ear -= dt; S.shift -= dt;
      if (S.blink < -0.14) S.blink = 3 + Math.random() * 5;
      S.blinkA = S.blink < 0 ? Math.sin((1 + S.blink / 0.14) * Math.PI) : 0;
      if (S.ear < -0.5) S.ear = 4 + Math.random() * 7;
      S.earA = S.ear < 0 ? Math.sin(-S.ear / 0.5 * Math.PI * 2) * 5 : 0;
      if (!moving && S.shift < -2.4) S.shift = 9 + Math.random() * 8;
      S.shiftA = (!moving && S.shift < 0) ? Math.sin(-S.shift / 2.4 * Math.PI) : 0;
      S.look = lerp(S.look, S.target ? 1 : 0, 1 - Math.exp(-dt * 4));

      /* lance up once he has pulled up and settled, pennant a beat later */
      var settled = S.target && Math.abs(S.v) < 14 && S.turnT >= 1;
      if (settled) tipWait += dt; else tipWait = 0;
      S.lance = lerp(S.lance, (settled && tipEl) ? 1 : 0,
                     1 - Math.exp(-dt * (settled ? 7 : 11)));
      if (tipEl) showTip(tipWait > 0.34);
      /* The lance is still coming down when the flag appears, so keep the
         pennant pinned to the head until the shaft has finished settling —
         measuring it once left the flag anchored to a mid-swing position. */
      if (tipOn && S.lance < 0.999) placeTip();

      if (tipOn && !reduced) {
        S.flagT += dt;
        /* it snaps as it catches the air, then settles to a steady stir */
        waveFlag(S.flagT, 1 + 1.9 * Math.exp(-S.flagT * 2.6), S.face < 0);
      }

      pose();
      if (!reduced) stepTail(dt);
      root.style.transform = 'translate3d(' + S.x.toFixed(1) + 'px,0,0)';
    }

    measure();
    S.x = S.tx = M.home;
    retarget();
    S.face = M.facing;
    S.faceA = S.turnTo = S.turnFrom = S.face > 0 ? 180 : 0;
    flip.style.transform = 'rotateY(' + S.faceA + 'deg)';
    root.classList.add('is-ready');
    requestAnimationFrame(frame);
    setTimeout(remeasure, 400);
    setTimeout(remeasure, 1600);
  }

  function boot() {
    var list = D.querySelectorAll('[data-bl-horse]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
